import React from 'react';

export default function HTML_Global_Attributes() {
  return (
    <div className="HTML_Global_Attributes">
      <h1>HTML Global Attributes</h1>
      <p>This is the placeholder component for <strong>HTML Global Attributes</strong>.</p>
      <p>Link: /html/reference/global-attributes</p>
    </div>
  );
}
